import { render, staticRenderFns } from "./IconMagnifyingGlass.vue?vue&type=template&id=5ccf01be"
import script from "./IconMagnifyingGlass.vue?vue&type=script&lang=js"
export * from "./IconMagnifyingGlass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports